import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable */
//tslint:disable
var defaultConfig = {
  apiType: 'public',
  assertStatusCodes: [204, 400],
  method: 'POST',
  microserviceName: 'users',
  pathApi: '/v1/remind-password/',
  hostType: 'api'
};

function createRemindPasswordModel(parameters) {
  return _objectSpread(_objectSpread({}, defaultConfig), {}, {
    parameters: parameters
  });
}

function fetchRemindPassword(_x) {
  return _fetchRemindPassword.apply(this, arguments);
}

function _fetchRemindPassword() {
  _fetchRemindPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var httpApi, parameters, config, mappers, _yield$httpApi$fetch, response, statusCode;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            httpApi = _ref.httpApi, parameters = _ref.parameters, config = _ref.config, mappers = _ref.mappers;
            _context.next = 3;
            return httpApi.fetch(createRemindPasswordModel(parameters), config);

          case 3:
            _yield$httpApi$fetch = _context.sent;
            response = _yield$httpApi$fetch.response;
            statusCode = _yield$httpApi$fetch.statusCode;

            if (!(mappers && statusCode in mappers)) {
              _context.next = 11;
              break;
            }

            if (!(statusCode === 204)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", mappers[204]());

          case 9:
            if (!(statusCode === 400)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return", mappers[400](response));

          case 11:
            return _context.abrupt("return", {
              response: response,
              statusCode: statusCode
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchRemindPassword.apply(this, arguments);
}

export { defaultConfig, createRemindPasswordModel, fetchRemindPassword };